import { CanDeactivateFn } from '@angular/router';
import { ISettingsConfigComponent } from '../../models/util/settingsConfig';
import { inject } from '@angular/core';
import { ToasterService } from '../../services/toaster/toaster.service';
import { isValidFunction, isValidString } from '@pineapplelab/util';
import { AuthService } from '../../services/auth/auth.service';

export const settingsChangesGuard: CanDeactivateFn<ISettingsConfigComponent> = (component, currentRoute, currentState, nextState) => {
	const toasterService = inject(ToasterService);
	const authService = inject(AuthService);

	if (authService.getIsLoggingOut()) {
		return true;
	}

	if (component.hasDataChanged()) {
		const message = isValidFunction(component.getDeniedExitMessage) && isValidString(component.getDeniedExitMessage()) ? component.getDeniedExitMessage() : 'account.confirm_changes';
		toasterService.showError(message);
		return false;
	}

	return true;
};
